<script>
import NotificationData from "./Steps/Data";
import Scheduling from "./Steps/Scheduling/Index";
import Users from "./Steps/Users";
import Cities from "./Steps/Cities";
import Districts from "./Steps/Districts";
import States from "./Steps/States";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      loader: false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  components: {
    NotificationData,
    Scheduling,
    Users,
    Cities,
    Districts,
    States
  },
  computed: {
    ...mapState("sendNotifications", [
      "step",
      "steps",
      "users",
      "accountStatus",
      "title",
      "message",
      "validNotification"
    ])
  },
  watch: {
    title: () => this.isValidNotification,
    message: () => this.isValidNotification
  },
  methods: {
    ...mapActions("sendNotifications", [
      "send",
      "setStep",
      "setMessage",
      "setTitle",
      "setDates",
      "setUsers",
      "setStates",
      "setCities",
      "setDistricts",
      "setAccountStatus",
      "isValidNotification",
      "clearState"
    ]),
    closeDialog() {
      this.$emit("close");
    },
    async sendNotifications() {
      this.loader = true;
      await this.send();
      this.loader = false;
      this.clearState();
      this.closeDialog();
    },
    setValidNotification() {
      this.validNotification = true;
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline text-uppercase font-weight-medium">
          Enviar notificação
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          rounded
          icon
          outlined
          @click="clearState() && closeDialog()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0" v-if="isValidNotification">
        <v-stepper class="elevation-0" :value="step" @change="setStep">
          <v-stepper-header class="elevation-0">
            <template v-for="(n, index) in steps">
              <v-stepper-step
                v-if="isValidNotification()"
                edit-icon="check"
                :complete="step > index + 1"
                :key="`${index}-step`"
                :step="index + 1"
                >{{ n.title }}</v-stepper-step
              >
              <v-divider v-if="index !== steps.length" :key="index"></v-divider>
            </template>
          </v-stepper-header>

          <v-divider></v-divider>

          <v-stepper-items>
            <v-stepper-content
              class="py-4"
              v-for="(n, index) in steps"
              :key="`${index}-content`"
              :step="index + 1"
            >
              <component :is="n.component"></component>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="step > 1"
          color="primary"
          text
          rounded
          @click="setStep(step - 1)"
        >
          <v-icon>navigate_before</v-icon>anterior
        </v-btn>
        <v-btn
          v-if="step < steps.length"
          color="primary"
          rounded
          :disabled="!validNotification"
          @click="setStep(step + 1)"
        >
          próximo
          <v-icon right>navigate_next</v-icon>
        </v-btn>
        <v-btn
          v-if="step === steps.length"
          color="primary"
          rounded
          :loading="loader"
          @click="sendNotifications()"
        >
          enviar notificação
          <v-icon right small>send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Index.vue